import React, { useState, useEffect } from 'react';

const TagsPage = () => {
  const [tags, setTags] = useState([]);
  const [name, setName] = useState('');
  const [selectedColor, setSelectedColor] = useState('#3b82f6');
  const [loading, setLoading] = useState(false);



// Estado para saber qué etiqueta se está editando
const [editingTag, setEditingTag] = useState(null);

// Estados temporales para el formulario de edición
const [editName, setEditName] = useState("");
const [editColor, setEditColor] = useState("");

const API_URL = process.env.REACT_APP_API_URL; // URL de tu API externa para notificar nuevos clientes

// Una vez seleccionada, llenas los estados 
const handleSelectForEdit = (tag) => {
  setEditingTag(tag);
  setEditName(tag.name);
  setEditColor(tag.color);
};

// Función para procesar el submit de actualización
const handleEditSubmit = async (e) => {
  e.preventDefault();
  // Lógica para actualizar en tu API o estado global

  setLoading(true);

  try {
    const response = await fetch(`${API_URL}tags/edit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: editingTag.id, name: editName, color: editColor }),
    });

    if (response.ok) {
      const updatedTag = await response.json();
      // Actualizamos el estado local de tags con la etiqueta editada
      setTags((prevTags) => prevTags.map(tag => tag.id === updatedTag.id ? updatedTag : tag));
      // setEditingTag(null); // Limpiamos el estado de edición
    } else {
      const errorData = await response.json();
      alert(`Error: ${errorData.error || 'No se pudo actualizar'}`);
    }
  } catch (error) {
    console.error("Error de conexión:", error);
    alert("Error de conexión");
  } finally {
    setLoading(false);
  }
};
  

const colorPalette = [
  // 🔴 Rojos (Cálidos, intensos)
  '#b91c1c', '#dc2626', '#ef4444', 

  // 🟠 Naranjas (Transición al calor)
  '#f97316', '#ea580c', '#c2410c', 

  // 🟡 Amarillos / Ámbar (Saturados, no pálidos)
  '#f59e0b', '#d97706', '#b45309',

  // 🟢 Verdes (Bosque y Esmeralda)
  '#15803d', '#16a34a', '#10b981', '#059669', '#047857',

  // 🔵 Azules (Cian a Profundo)
  '#0891b2', '#0284c7', '#2563eb', '#1d4ed8', '#1e3a8a',

  // 🟣 Índigos / Violetas
  '#4f46e5', '#4338ca', '#3730a3', 

  // 🟪 Morados / Púrpuras
  '#7c3aed', '#6d28d9', '#5b21b6',

  // 🌸 Rosas / Magentas (Cierre del círculo)
  '#db2777', '#be185d', '#9d174d',

  // ⚫ Neutros Escala de Grises (Sin blancos ni grises claros)
  '#4b5563', '#374151', '#1f2937', '#111827', '#000000'
];



useEffect(() => {
    // 1. La función se define dentro del useEffect
    async function fetchTags() {
      try {
        setLoading(true); // Opcional: útil si quieres mostrar un loader
        const response = await fetch(`${API_URL}tags`);
        
        // 2. Validamos que la respuesta del servidor sea exitosa (código 200-299)
        if (!response.ok) {
          throw new Error(`Error en la petición: ${response.status}`);
        }
        
        const data = await response.json();
        setTags(data);
      } catch (error) {
        console.error("Error cargando etiquetas:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchTags();
  }, [API_URL]); // Se recomienda incluir variables externas usadas dentro del hook

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) return alert("El nombre es obligatorio");

    setLoading(true);

    try {
      const response = await fetch(`${API_URL}tags/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, color: selectedColor }),
      });

      if (response.ok) {
        const newTag = await response.json();
        
        // 2. ACTUALIZACIÓN SIN RECARGAR:
        // Agregamos la nueva etiqueta al estado actual
        setTags((prevTags) => [...prevTags, newTag]);
        
        // Limpiar el formulario
        setName('');
        setSelectedColor('#3b82f6');
      } else {
        const errorData = await response.json();
        alert(`Error: ${errorData.error || 'No se pudo crear'}`);
      }
    } catch (error) {
      alert("Error de conexión");
    } finally {
      setLoading(false);
    }
  };



return (
    <div className='tags-page' style={styles.pageWrapper}>
      <h1 style={styles.mainTitle}>Administración de Etiquetas</h1>
      
      <div style={styles.layout}>
        {/* COLUMNA IZQUIERDA: Formulario de Creación */}
        <div style={styles.formColumn}>
          <div style={styles.card}>
            <h2 style={styles.subtitle}>Nueva Etiqueta</h2>
            <form onSubmit={handleSubmit} style={styles.form}>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Nombre</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  style={styles.input}
                  placeholder="Ej: Cliente VIP"
                  disabled={loading}
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Color</label>
                <div style={styles.palette}>
                  {colorPalette.map((color) => (
                    <div
                      key={color}
                      onClick={() => setSelectedColor(color)}
                      style={{
                        ...styles.colorOption,
                        backgroundColor: color,
                        border: selectedColor === color ? '3px solid #333' : '1px solid #ddd',
                        transform: selectedColor === color ? 'scale(1.15)' : 'scale(1)',
                      }}
                    />
                  ))}
                </div>
              </div>

              <button type="submit" style={styles.button} disabled={loading}>
                {loading ? 'Guardando...' : 'Guardar Etiqueta'}
              </button>
            </form>
          </div>
        </div>



        {/* COLUMNA DERECHA: Listado y Edición */}
        <div style={styles.listColumn}>
          {/* TARJETA 2: Editar Etiquetas */}
          <div style={{ ...styles.card}}>
            <h2 style={styles.subtitle}>Editar Etiqueta</h2>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
              Selecciona una etiqueta para modificarla:
            </p>
            
            {/* Lista interactiva para seleccionar */}
            <div style={styles.tagsGrid}>
              {tags.map((tag, index) => (
                <div 
                  key={`edit-list-${index}`} 
                  onClick={() => {
                    // Aquí deberías tener una función que actualice el estado de edición
                    setEditingTag(tag); setEditName(tag.name); setEditColor(tag.color);
                  }}
                  style={{ 
                    ...styles.tagBadge, 
                    backgroundColor: tag.color,
                    cursor: 'pointer',
                    opacity: 0.9,
                    // Si tienes un estado `editingTag`, puedes destacar el seleccionado:
                    border: editingTag?.id === tag.id ? '2px solid #000' : 'none'
                  }}
                  title="Clic para editar"
                >
                  {tag.name} ✎
                </div>
              ))}
            </div>

            {/* Formulario de Edición (Idealmente condicionado a si hay un editingTag) */}
            {/* Ejemplo: {editingTag && ( ... )} */}
            <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
              <form onSubmit={handleEditSubmit} style={styles.form}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>Actualizar Nombre</label>
                  <input
                    type="text"
                    value={editName}
                    onChange={(e) => setEditName(e.target.value)}
                    style={styles.input}
                    placeholder="Nuevo nombre"
                    disabled={loading}
                  />
                </div>

                <div style={styles.inputGroup}>
                  <label style={styles.label}>Actualizar Color</label>
                  <div style={styles.palette}>
                    {colorPalette.map((color) => (
                      <div
                        key={`edit-${color}`}
                        onClick={() => setEditColor(color)}
                        style={{
                          ...styles.colorOption,
                          backgroundColor: color,
                          border: editColor === color ? '3px solid #333' : '1px solid #ddd',
                          transform: editColor === color ? 'scale(1.15)' : 'scale(1)',
                        }}
                      />
                    ))}
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '10px' }}>
                  <button type="submit" style={{ ...styles.button, flex: 1 }} disabled={loading}>
                    {loading ? 'Actualizando...' : 'Actualizar'}
                  </button>
                  <button 
                    type="button" 
                    onClick={() => setEditingTag(null)} 
                    style={{ ...styles.button, backgroundColor: '#888', flex: 1 }} 
                    disabled={loading}
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>

          </div>
        </div>

      </div>
    </div>
  );

}

const styles = {
  pageWrapper: { padding: '40px', maxWidth: '1200px', margin: '0 auto', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' },
  mainTitle: { marginBottom: '30px', color: '#1a202c' },
  layout: { display: 'flex', gap: '30px', alignItems: 'flex-start' },
  formColumn: { flex: '1' },
  listColumn: { flex: '1.5' },
  card: { background: '#fff', padding: '25px', borderRadius: '15px', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)', border: '1px solid #edf2f7' },
  subtitle: { marginTop: 0, marginBottom: '20px', fontSize: '1.1rem', color: '#4a5568', borderBottom: '1px solid #eee', paddingBottom: '10px' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  inputGroup: { display: 'flex', flexDirection: 'column', gap: '8px' },
  label: { fontSize: '14px', fontWeight: 'bold', color: '#4a5568' },
  input: { padding: '12px', borderRadius: '8px', border: '1px solid #cbd5e0', fontSize: '16px' },
  palette: { display: 'flex', flexWrap: 'wrap', gap: '8px' },
  colorOption: { width: '32px', height: '32px', borderRadius: '50%', cursor: 'pointer', transition: 'all 0.2s' },
  button: { padding: '14px', backgroundColor: '#25d366', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer' },
  tagsGrid: { display: 'flex', flexWrap: 'wrap', gap: '10px' },
  tagBadge: { padding: '6px 14px', borderRadius: '20px', color: '#fff', fontSize: '13px', fontWeight: '600', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', textTransform: 'capitalize' }
};

  

export default TagsPage;